<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM3.6 24C3.6 35.2666 12.7334 44.4 24 44.4C35.2666 44.4 44.4 35.2666 44.4 24C44.4 12.7334 35.2666 3.6 24 3.6C12.7334 3.6 3.6 12.7334 3.6 24Z"
            fill="currentColor"
            id="progress-circle"
        />
        <path
            d="M17.54 29.1846C15.1748 29.1846 13.7734 27.2021 13.7734 24.0576C13.7734 20.9336 15.1885 18.9512 17.54 18.9512C19.8984 18.9512 21.293 20.9268 21.293 24.0508C21.293 27.1953 19.9053 29.1846 17.54 29.1846ZM17.54 27.8994C18.9482 27.8994 19.748 26.4434 19.748 24.0576C19.748 21.7061 18.9346 20.2363 17.54 20.2363C16.1455 20.2363 15.3252 21.7129 15.3252 24.0576C15.3252 26.4365 16.1318 27.8994 17.54 27.8994ZM23.2139 31.1055H21.9014L25.4014 19.1357H26.7139L23.2139 31.1055ZM27.3975 22.0273C27.3975 20.25 28.8262 18.9512 30.7881 18.9512C32.668 18.9512 34.0693 20.1475 34.0693 21.7129C34.0693 22.8613 33.4541 23.7158 32.0117 25.1924L29.5439 27.6738V27.708H34.2266V29H27.4795V27.9609L31.041 24.3311C32.2441 23.0801 32.5586 22.5605 32.5586 21.7881C32.5586 20.9131 31.7656 20.2158 30.7402 20.2158C29.6602 20.2158 28.8467 20.9951 28.8467 22.0205V22.041H27.3975V22.0273Z"
            fill="currentColor"
            id="progress-digits"
        />
    </svg>
</template>
